import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import AppHeader from '../components/AppHeader';
import RegistrationForm from '../components/RegistrationForm';
import { RouteComponentProps } from 'react-router';

const Register: React.FC<RouteComponentProps> = ({ history }) => {
  return (
    <IonPage>
      <AppHeader />
      <IonContent className="ion-padding-bottom">
        <div className="wrapper wrapper--stretch">
          <div className="ion-padding">
            <h2 className="ion-text-center">S'inscrire</h2>
            <RegistrationForm
              onRegisterSuccess={() => {
                history.push('/dashboard/resume');
              }}
              onRegisterError={() => {}}
            />
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Register;
